import React from 'react';

import Spinner from '../resources/assets/Spinner_font_awesome.svg';
import './Overlay.css';

export default function Overlay(props) {
  return (<div className="overlay">
    <img className="image" src={Spinner} alt="" width="120" height="120"></img>
  </div>);
}